// vendor
// window.jQuery = window.$ = require('jquery');
import './scripts/vendor/fontAwesome.js';

// Tracking
import CollectTracking from './scripts/application/tracking.js';

// application
import { Base64 } from './scripts/application/encoding-content';
import general from './scripts/application/general.js';
import cookies from './scripts/application/cookies.js';
import chartsBar from './scripts/application/modules/bar-chart.js';

// PAGES
import pageIndex from './scripts/application/pages/index.js';
import pageEvents from './scripts/application/pages/events.js';
import pageSchools from './scripts/application/pages/schools.js';
import pageSchoolsParticipating from './scripts/application/pages/schools-participating.js';
import pageVideos from './scripts/application/pages/videos.js';

/**
 * Method to encode some content
 */
function encodedContent() {
    /**
     * Encoded content
     */
    const content = {
        '07f470288bff669b40beb568c20550ab': 'PGEgaHJlZj0iaHR0cHM6Ly9hY2NvdW50LmFkdmVudGdyb3VwLm5ldC9sb2dpbiIgcmVsPSJub2ZvbGxvdyI+U2Nob29sIExvZ2luPC9hPg==',
        '1e7fad1fd1d02557134f702ddecd9068': 'PGEgaHJlZj0iaHR0cHM6Ly9hY2NvdW50LmFjY2Vzc21iYS5jb20vY2FuZGlkYXRlcy9yZWdpc3RyYXRpb24vbG9naW4vbWJhIiByZWw9Im5vZm9sbG93Ij5DYW5kaWRhdGUgTG9naW48L2E+'
    };

    /**
     * Encoded links
     */
    const links = {};

    /**
     * Find the elements that need to be encoded
     */
    document.querySelectorAll('[hashstring]').forEach(element => {
        let key = element.getAttribute("hashstring");

        /**
         * Get the type of the hash for the element
         * and decode the element content
         */
        if (element.getAttribute("hashtype") === 'href' && typeof links[key] !== 'undefined') {
            return element.setAttribute('href', Base64.decode(links[key]));
        }

        /**
         * Decode the element content
         */
        return element.parentNode.innerHTML = Base64.decode(content[key]);
    });
}

/**
 * Initialize the application
 */
window.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 901) {
        general.toggleMenu('.dropdown-toggle', '.dropdown-menu');
    }

    /**
     * Initialize the method that will collect the tracking information
     */
    CollectTracking();

    /**
     * Initialize the method for the elements
     */
    general.toggleBtn();
    general.header.search();
    //general.header.initHeadroom();
    general.switchSlider();
    general.accordion();
    general.featuredSchoolsSideBar();
    general.socialShare();
    general.readMore();

    chartsBar();
    cookies();
    encodedContent();

    // Execute the methods
    Object.keys(pageIndex).forEach(key => pageIndex[key]());

    // Execute the methods
    Object.keys(pageEvents).forEach(key => pageEvents[key]());

    // Execute the methods
    Object.keys(pageSchools).forEach(key => pageSchools[key]());

    // Execute the methods
    Object.keys(pageSchoolsParticipating).forEach(key => pageSchoolsParticipating[key]());

    // Execute the methods
    Object.keys(pageVideos).forEach(key => pageVideos[key]());
});
